// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MQyLp","oopsTitle":"styles_oopsTitle__wQcQ9"};